import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { SVGIcon, filePdfIcon, fileExcelIcon, pencilIcon, trashIcon } from '@progress/kendo-svg-icons';
import { process } from '@progress/kendo-data-query';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ExcelExportModule } from "@progress/kendo-angular-excel-export";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { PDFExportModule } from "@progress/kendo-angular-pdf-export";
import { PDFViewerModule } from "@progress/kendo-angular-pdfviewer";
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteModalComponent } from 'app/confirm-delete-modal/confirm-delete-modal.component';
import { GridService } from 'app/services/grid.service';
import { PageService } from 'app/services/page.service';
import { SelectEvent } from '@progress/kendo-angular-charts';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DrakeCustomComponentComponent } from 'app/drake-components/drake-custom-component/drake-custom-component.component';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { TranslocoPipe } from '@ngneat/transloco';
import { LayoutModule } from '@progress/kendo-angular-layout';


@Component({
  selector: 'app-drake-custom-page',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    TabStripModule,
    HttpClientModule,
    ExcelExportModule,
    ButtonsModule,
    PDFExportModule,
    PDFViewerModule,
    MatDialogModule,
    DrakeCustomComponentComponent,
    TranslocoPipe,
    LayoutModule
  ],
  templateUrl: './drake-custom-page.component.html',
  styleUrl: './drake-custom-page.component.scss'
})
export class DrakeCustomPageComponent implements OnInit {
  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
  public pageData: any;
  public baseData: any = {  };
  constructor(private router: Router, private activatedRoute: ActivatedRoute, pageService: PageService, drakeShared: DrakeSharedService) {
    drakeShared.currentBaseData = this.baseData;
    this.activatedRoute.params.subscribe(params => {
      pageService.getPage(params?.['pageCode']).subscribe((result: any) => {
        this.pageData = result;
        drakeShared.currentPageData = result;
      });
    })

  }

  ngOnInit(): void {
  }

  public onTabSelect(e: SelectEvent): void {
    console.log(e);
  }

}
